export default __webpack_public_path__ + "static/process-payments-964916c81703fe9386ed0877fce77061.png";